export default function jsSkillAcd() 
  {
  // -----------------------------------------------------
  // スキルアコーディオン
  // -----------------------------------------------------
  const skillacd = document.getElementsByClassName("js_skill_acd")

  function toggle_skill() {
    const content = this.nextElementSibling
    this.classList.toggle("is-active")
    content.classList.toggle("is-open")

    // ★★★ 2021-6-22
    // ↓ここが入らなくなったので削除しました

    // if (this.classList.contains("is-active")) {
    //   var conH = content.clientHeight

    //   conH = conH + 60
    //   this.parentNode.style.height = conH + "px"
    // } else {
    //   if (window.innerWidth >= 750) {
    //     this.parentNode.style.height = "58px"
    //   } else if (window.innerWidth < 750) {
    //     this.parentNode.style.height = "36px"
    //   }
    // }
  }

  for (let i = 0; i < skillacd.length; i++) {
    skillacd[i].addEventListener("click", toggle_skill)
  }

  // ---------------------------------------

  const skilMenu = document.getElementsByClassName("js_skill_acd__")

  function toggle_skill2() {
    const content = this.nextElementSibling
    this.classList.toggle("is-active")
    content.classList.toggle("is-open")
    if (this.classList.contains("is-active")) {
      this.parentNode.style.height = "auto"
    } else {
      if (window.innerWidth >= 750) {
        this.parentNode.style.height = "58px"
      } else if (window.innerWidth < 750) {
        this.parentNode.style.height = "36px"
      }
    }
  }

  for (let i = 0; i < skilMenu.length; i++) {
    skilMenu[i].addEventListener("click", toggle_skill2)
  }

  // ---------------------------------------

  const skilMenu2 = document.getElementsByClassName("js_skill_acd__")

  function toggle_skill3() {
    const content = this.nextElementSibling
    this.classList.toggle("is-active")
    content.classList.toggle("is-open")
  }

  for (let i = 0; i < skilMenu2.length; i++) {
    skilMenu2[i].addEventListener("click", toggle_skill3)
  }
}
